import { atom } from "@mongez/react-atom";

export const productFinalPriceAtom = atom<number>({
  key: "product-final-price",
  default: 0,
});
